import { render, staticRenderFns } from "./ContactCoordsEdit.vue?vue&type=template&id=2cb4546a"
import script from "./ContactCoordsEdit.vue?vue&type=script&lang=ts"
export * from "./ContactCoordsEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports